/**
window.FCAbroadMobile.config({
    ctn: inputWrap,
    width: 100,
    height: 40,
    onChoose: function(val) {
        console.log(val);
    }
})

window.FCAbroadMobile.check()
window.FCAbroadMobile.show()
window.FCAbroadMobile.hide()
window.FCAbroadMobile.onChoose = function() {

}
**/

window.FCAbroadMobile = function(cfg) {
    this.curSelect = '+86';

    this._cfg = {
        domain: 'login',
        ctn: 'inputCtn', //
        width: 100, //
        height: 40, //
        itemHeight: 30,
        itemNum: 7,
        onChoose: null, //
        disabled: false

    };
    this._cfg = $.extend({}, this._cfg, cfg);

    this.init();

}
window.FCAbroadMobile.prototype = {

    init: function () {
        var that = this;

        var $ctn = typeof that._cfg.ctn === 'string' ? $(that._cfg.ctn) : that._cfg.ctn;
        $ctn.css({
            'position': 'relative',
            'overflow': 'visible'
        })

        that.appendStyle(that._template(that.styleTxt, {
            domain: that._cfg.domain,
            height: that._cfg.height,
            width: that._cfg.width,
            pop_top: that._cfg.height - 1,
            itemHeight: that._cfg.itemHeight,
            input_width: that._cfg.width - 50,
            max_pop_height: that._cfg.itemHeight * that._cfg.itemNum
        }));

        $ctn.html(that._template(that._tpl_input, {
            domain: that._cfg.domain
        }));

        that.$el = $ctn.find('.FCMobile-wrap_' + that._cfg.domain);
        that.$input = that.$el.find('.FCMobile-input');
        that.$label = that.$el.find('.FCMobile-input-label');

        if (that._cfg.disabled) {
            that.$input.attr('disabled', true)
            // return; // 这期没存区号 所以可选
        }

        $.ajax({
            url: '/captcha/cacode',
            type: 'get',
            success: function(res) {
                if (res.code == '200') {

                    that.data = res.data;

                    // 设置默认区码
                    that.$el.find('.FCMobile-input-label').html('+' + res.data.defaultCACode.code);

                    that._renderPop(res.data);

                    that.$pop = that.$el.find('.FCMobile-pop');

                    that._addEvt();
                }


            },
            failure: function(res) {

            }

        })


    },

    _addEvt: function() {
        var that = this;
        that.$label.on('click', function() {
            that.$pop.css('display') == 'none' ? that.show() : that.hide();
        });

        that.$el.on('click', '.FCMobile-item, .FCMobile-dft', function() {
            that.curSelect = $(this).find('.FCMobile-item_right').html()

            that.$el.find('.FCMobile-item').removeClass('cur')
            $(this).addClass('cur');

            that.$label.html(that.curSelect);

            that.hide();

            that.$input.trigger('FCMobile_SELECT', that.curSelect)

        });

    },

    show: function (cfg) {
        this.$pop.slideDown();
    },

    hide: function (cfg) {
        this.$pop.slideUp();
    },

    set: function (code, mobile) {
        if (code) {
            this.curSelect = '+' + code;
            this.$label.html(this.curSelect);
        }

        if (mobile) {
            this.curSelectVal = mobile;
            this.$input.val(this.curSelectVal)

        }

    },

    getData: function() {

    },
    getCode: function() {
        return this.$label.html().replace('+', '')
    },

    _renderPop: function(data) {

        this.$el.append(this._tpl_pop);

        this.$el.find('.FCMobile-dft').html(
            this._template(this._tpl_item, data.defaultCACode)
        )

        if (this.curSelect == ( '+' + data.defaultCACode.code)) {
            this.$el.find('.FCMobile-dft').addClass('cur')
        }

        var tmp = [];
        for (var i = 0; i < data.topCACodes.length; i++) {
            var item = data.topCACodes[i];
            var cur = false;

            if (this.curSelect == ('+' + item.code)) {
                cur = true

            }
            tmp.push('<li class="FCMobile-item '+ (cur ? 'cur':'') +'">' +
                this._template(this._tpl_item, item) + '</li>')
        }
        this.$el.find('.FCMobile-list').html(tmp.join(''));

    },

    check: function() {
        let pattern = this._patternMap[this.curSelect];

        if (!this.$input.val()) {
            return false
        }
        if (!pattern) {
            return true;
        }
        if (pattern.test(this.$input.val())) {
            // console.log(pattern, 'true');
            return true
        } else {
            // console.log(pattern, 'false');
            return false
        }

    },

    _patternMap: {
        '+86': /^1[0-9]{10}$/,
        '+1': /^\d{10}$/,
        '+60': /^((0?10|0?12|0?13|0?14|0?16|0?17|0?18|0?19)\d{7})|(0?11\d{8})$/,
        '+66': /^(0?)8[0-9]{8}$/,
        '+61': /^(0?)4[0-9]{8}$/,
        '+81': /^(0?70|0?80|0?90)[0-9]{8}$/,
        '+44': /^(0?)7[0-9]{9}$/,
        '+853': /^6[0-9]{7}$/,
        '+852': /^[69][0-9]{7}$/
    },

    _template: function(template, data) {
        // {a} b
        var tokenReg = /\{\{([^\{\}\\]+)\}\}/g;

        return template.replace(tokenReg, function ($, $1) {
            return $.replace($, data[$1]);
        })
    },

    _tpl_input: `
    <div class="FCMobile-wrap_{{domain}}">
        <div class="FCMobile-input-wrap">
            <span class="FCMobile-input-label">+86</span>
            <input class="FCMobile-input" placeholder="手机号码"></input>
        </div>
    </div>
    `,

    _tpl_pop: `
        <div class="FCMobile-pop">
            <div class="FCMobile-dft">

            </div>
            <ul class="FCMobile-list">

            </ul>
        </div>
    `,

    _tpl_item: `
        <span class="FCMobile-item_left">{{nameZh}}</span>
        <span class="FCMobile-item_right">+{{code}}</span>`,

    styleTxt: `

        .FCMobile-wrap_{{domain}} {

        }
        .FCMobile-wrap_{{domain}} .FCMobile-input-wrap {
            position: relative;
            width: {{width}}px;
            height: {{height}}px;
            border: 1px solid #ddd;
            line-height: {{height}}px;
            box-sizing: border-box;
        }
        .FCMobile-wrap_{{domain}} .FCMobile-input-label {
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            padding: 0 10px;
            cursor: pointer;
            font-size: 14px;
            color: #333;
        }
        .FCMobile-wrap_{{domain}} .FCMobile-input {
            margin-left: 44px;
            display: block;
            width: {{input_width}}px;
            height: 100%;
            border: none;
            text-indent: 15px;
            font-size: 14px;
            color: #333;
        }

        .FCMobile-wrap_{{domain}} .FCMobile-pop {
            display: none;
            position: absolute;
            top: {{pop_top}}px;
            width: 100%;
            z-index: 999;
            font-size: 12px;
            color: #666;
            background-color: #fff;
            border: 1px solid #D8D8D8;
            box-sizing: border-box;

            max-height: {{max_pop_height}}px;
            overflow: scroll;
        }

        .FCMobile-wrap_{{domain}} .FCMobile-list{

        }
        .FCMobile-wrap_{{domain}} .FCMobile-dft, .FCMobile-item{
            height: {{itemHeight}}px;
            line-height: {{itemHeight}}px;
            padding: 0 28px 0 10px;
            cursor: pointer;
            text-align: left;
        }
        .FCMobile-wrap_{{domain}} .FCMobile-dft {
            border-bottom: 1px solid #D8D8D8;

        }
        .FCMobile-wrap_{{domain}} .FCMobile-item.cur {
            background: #F8F8F8;
        }
        .FCMobile-wrap_{{domain}} .FCMobile-item_right {
            float: right;
        }
    `,

    appendStyle: function(str) {
        var domainInit = 'FCAbroadMobile' + this._cfg.domain + '_inited';

        if (!!window[domainInit]) {
            return
        }

        window[domainInit] = true;

        var nod = document.createElement('style');
        nod.type='text/css';
        if(nod.styleSheet){         //ie下
            nod.styleSheet.cssText = str;
        } else {
            nod.innerHTML = str;       //或者写成 nod.appendChild(document.createTextNode(str))
        }
        document.getElementsByTagName('head')[0].appendChild(nod)
    }

}



// WEBPACK FOOTER //
// ./src/module/abroad-mobile.js